<template>
  <b-skeleton-wrapper :loading="loading">
    <template #loading>
      <b-card>
        <b-skeleton width="85%"></b-skeleton>
        <b-skeleton width="55%"></b-skeleton>
        <b-skeleton width="70%"></b-skeleton>
      </b-card>
    </template>

    <div class="nameserver-table">
      <div class="title">
        <h3>PLUSCLOUDS NAMESERVERS</h3>
      </div>

      <div class="table-responsive">
        <table class="table" style="width: 100%">
          <thead>
            <tr>
              <th scope="col" style="width: 90px">Type</th>
              <th scope="col">Value</th>
            </tr>
          </thead>
          <tr v-for="(item, index) in nameServers" :key="index">
            <td>NS</td>
            <td>
              {{ item.nameserver }}
              <Label v-if="item.is_ok" class="running ml-3">{{
                $t('dns.working')
              }}</Label>
              <Label
                v-if="!item.is_ok"
                v-b-tooltip.hover.html="item.problem"
                class="inactive ml-3 cursor-pointer"
                >{{ $t('dns.notWorking') }}</Label
              >
            </td>
          </tr>
        </table>
      </div>

      <div class="background-icon">
        <i class="fas fa-info"></i>
      </div>
    </div>
  </b-skeleton-wrapper>
</template>

<script>
// Services
import ApiService from '@/core/services/api.service'

export default {
  name: 'NameServerList',
  data() {
    return {
      nameServers: [],
      loading: false,
    }
  },
  created() {
    this.getNameServers()
  },
  methods: {
    getNameServers() {
      this.loading = true
      ApiService.get(
        `packetbender/dns/tests/nameservers/${this.$route.params.id}`
      )
        .then(({ data }) => {
          if (data) {
            // Ordered/Sort Data
            let orderedData = Object.keys(data)
              .sort()
              .reduce((obj, key) => {
                obj[key] = data[key]
                return obj
              }, {})

            this.nameServers = orderedData
            this.loading = false
          }
        })
        .catch((err) => {
          console.log(err)
          this.nameServers = []
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss">
.nameserver-table {
  position: relative;
  background: #fff;
  border: 1px solid #ebedf2;
  padding: 20px;
  border-radius: 12px;

  .title {
    margin-bottom: 20px;

    h3 {
      font-size: 16px;
      line-height: 24px;
      font-weight: 500;
      color: #b5b5c3;
      margin-bottom: 0;
    }
  }

  table {
    font-size: 14px;
    line-height: 21px;
    font-weight: 600;
    color: #464e5f;

    thead th {
      font-size: 12px;
      line-height: 18px;
      font-weight: 600;
      letter-spacing: 0.03em;
      color: #b5b5c3;
      padding-top: 0px;
      padding-bottom: 20px;
      padding-left: 0px;
    }

    tr td {
      padding: 14px 0px;
    }
  }

  .background-icon {
    position: absolute;
    top: 20px;
    right: 20px;

    i {
      font-size: 62px;
      line-height: 62px;
      color: #f6f7f9;
    }
  }
}
</style>
